/*var jqueryVariable = ""
console.log("dentro JS " + jqueryVariable);
if (jqueryVariable == "sinstock") {
  console.log("dentro IF");
  var elemento = document.getElementById('product-recommendations__inner');  
  console.log("id container "+elemento);
  
} */
function relacionados(){
var elemento = document.getElementById("product-recommendations__inner");
    console.log(elemento);
}
window.onload = relacionados;